import React, { useState } from "react";
import { Box } from "@mui/material";
import CustomModal from "../../../components/Modals/CustomModal";
import { STRINGS } from "../strings";
import { Styles } from "../Styles";
import { Button } from "../../../components/Buttons";
import TypographyInline from "../../../components/Typography/TypographyInline";
import { GREY } from "../../../utils/constants/colors";
import { fontWeight } from "../../../utils/constants/UI";
import RadioButton from "../../../components/RadioButton/RadioButton";
import { AutoCompleteCustom } from "../../../components/Autocomplete/AutoCompleteCustom";
import { selectData } from "../../../utils/constants";
import InputField from "../../../components/InputFields/InputField";
import TextArea from "../../../components/InputFields/TextArea";
import { postRequest } from "../../../Apis";
import { dashboardEndpoints } from "../../../utils/constants/httpConstants";
import { useNavigate } from "react-router-dom";

const ShareDashboardModal = ({ open, setOpen, dashboardID, widget }) => {
  console.log("DASHBRDID", dashboardID, "WDIGT", widget);
  let value =
  `
  <svg width="515.22" height="332.01"><g transform="translate(40,40)" style="margin-top: 50px; overflow: visible;">
  <g class="y axis-grid" stroke="#D3DAE3" stroke-width="1" opacity=".2" fill="none" font-size="10" font-family="sans-serif" text-anchor="end">
  <path class="domain" stroke="#D3DAE3" d="M435.22,262.51H0.5V0.5H435.22"></path><g class="tick" opacity="1" transform="translate(0,262.51)">
  <line stroke="currentColor" x2="435.22"></line><text fill="currentColor" x="-3" dy="0.32em"></text></g><g class="tick" opacity="1" transform="translate(0,0.5)">
  <line stroke="currentColor" x2="435.22"></line><text fill="currentColor" x="-3" dy="0.32em"></text></g></g>
  <path d="M0,262.01L62.174285714285716,262.01L124.34857142857143,262.01L186.52285714285713,262.01L248.69714285714286,262.01L310.8714285714286,262.01L373.04571428571427,262.01L435.22,262.01" fill="none" stroke="#89E9BF" stroke-width="2"></path><g><circle cx="0" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="62.174285714285716" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="124.34857142857143" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="186.52285714285713" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="248.69714285714286" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="310.8714285714286" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="373.04571428571427" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="435.22" cy="262.01" r="8" style="fill: transparent;"></circle></g><path d="M0,262.01L62.174285714285716,262.01L124.34857142857143,262.01L186.52285714285713,262.01L248.69714285714286,262.01L310.8714285714286,262.01L373.04571428571427,262.01L435.22,262.01" fill="none" stroke="#FFE187" stroke-width="2"></path><g><circle cx="0" cy="262.01" r="8" style="fill: transparent;">
  </circle><circle cx="62.174285714285716" cy="262.01" r="8" style="fill: transparent;">
  </circle><circle cx="124.34857142857143" cy="262.01" r="8" style="fill: transparent;">
  </circle><circle cx="186.52285714285713" cy="262.01" r="8" style="fill: transparent;">
  </circle><circle cx="248.69714285714286" cy="262.01" r="8" style="fill: transparent;">
  </circle><circle cx="310.8714285714286" cy="262.01" r="8" style="fill: transparent;">
  </circle><circle cx="373.04571428571427" cy="262.01" r="8" style="fill: transparent;">
  </circle><circle cx="435.22" cy="262.01" r="8" style="fill: transparent;"></circle></g>
  <path d="M0,262.01L62.174285714285716,262.01L124.34857142857143,262.01L186.52285714285713,262.01L248.69714285714286,262.01L310.8714285714286,262.01L373.04571428571427,262.01L435.22,262.01" fill="none" stroke="#E0A9FF" stroke-width="2"></path><g><circle cx="0" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="62.174285714285716" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="124.34857142857143" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="186.52285714285713" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="248.69714285714286" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="310.8714285714286" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="373.04571428571427" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="435.22" cy="262.01" r="8" style="fill: transparent;"></circle></g><path d="M0,262.01L62.174285714285716,262.01L124.34857142857143,262.01L186.52285714285713,262.01L248.69714285714286,262.01L310.8714285714286,262.01L373.04571428571427,262.01L435.22,262.01" fill="none" stroke-width="2"></path><g><circle cx="0" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="62.174285714285716" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="124.34857142857143" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="186.52285714285713" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="248.69714285714286" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="310.8714285714286" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="373.04571428571427" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="435.22" cy="262.01" r="8" style="fill: transparent;"></circle></g><path d="M0,262.01L62.174285714285716,262.01L124.34857142857143,262.01L186.52285714285713,262.01L248.69714285714286,262.01L310.8714285714286,262.01L373.04571428571427,262.01L435.22,262.01" fill="none" stroke="#95F5FC" stroke-width="2"></path><g><circle cx="0" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="62.174285714285716" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="124.34857142857143" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="186.52285714285713" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="248.69714285714286" cy="262.01" r="8" style="fill: transparent;">
  </circle>
  <circle cx="310.8714285714286" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="373.04571428571427" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="435.22" cy="262.01" r="8" style="fill: transparent;"></circle></g><path d="M0,262.01L62.174285714285716,262.01L124.34857142857143,262.01L186.52285714285713,262.01L248.69714285714286,262.01L310.8714285714286,262.01L373.04571428571427,262.01L435.22,262.01" fill="none" stroke="#92B4EC" stroke-width="2"></path><g><circle cx="0" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="62.174285714285716" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="124.34857142857143" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="186.52285714285713" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="248.69714285714286" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="310.8714285714286" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="373.04571428571427" cy="262.01" r="8" style="fill: transparent;">
  </circle><circle cx="435.22" cy="262.01" r="8" style="fill: transparent;">
  </circle></g>
  <path d="M0,262.01L62.174285714285716,262.01L124.34857142857143,262.01L186.52285714285713,262.01L248.69714285714286,262.01L310.8714285714286,262.01L373.04571428571427,262.01L435.22,262.01" fill="none" stroke="#989EAB" stroke-width="2"></path><g><circle cx="0" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="62.174285714285716" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="124.34857142857143" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="186.52285714285713" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="248.69714285714286" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="310.8714285714286" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="373.04571428571427" cy="262.01" r="8" style="fill: transparent;"></circle><circle cx="435.22" cy="262.01" r="8" style="fill: transparent;"></circle></g><g fill="none" font-size="10" font-family="sans-serif" text-anchor="middle" transform="translate(0,262.01)"><path class="domain" stroke="#D3DAE3" d="M0.5,0.5H435.72"></path><g class="tick" opacity="1" transform="translate(0.5,0)"><line stroke="currentColor" y2="0"></line><text fill="currentColor" y="10" dy="0.71em">23/10</text></g><g class="tick" opacity="1" transform="translate(62.674285714285716,0)"><line stroke="currentColor" y2="0"></line><text fill="currentColor" y="10" dy="0.71em">24/10</text></g><g class="tick" opacity="1" transform="translate(124.84857142857143,0)"><line stroke="currentColor" y2="0"></line><text fill="currentColor" y="10" dy="0.71em">25/10</text></g><g class="tick" opacity="1" transform="translate(187.02285714285713,0)"><line stroke="currentColor" y2="0"></line><text fill="currentColor" y="10" dy="0.71em">26/10</text></g><g class="tick" opacity="1" transform="translate(249.19714285714286,0)"><line stroke="currentColor" y2="0"></line><text fill="currentColor" y="10" dy="0.71em">27/10</text></g><g class="tick" opacity="1" transform="translate(311.3714285714286,0)"><line stroke="currentColor" y2="0"></line><text fill="currentColor" y="10" dy="0.71em">28/10</text></g><g class="tick" opacity="1" transform="translate(373.54571428571427,0)"><line stroke="currentColor" y2="0"></line><text fill="currentColor" y="10" dy="0.71em">29/10</text></g><g class="tick" opacity="1" transform="translate(435.72,0)">
  <line stroke="currentColor" y2="0"></line><text fill="currentColor" y="10" dy="0.71em">30/10</text></g></g><g fill="none" font-size="10" font-family="sans-serif" text-anchor="end"><path class="domain" stroke="#D3DAE3" d="M0.5,262.51V0.5"></path><g class="tick" opacity="1" transform="translate(0,262.51)"><line stroke="currentColor" x2="0"></line><text fill="currentColor" x="-6" dy="0.32em">0</text></g>
  <g class="tick" opacity="1" transform="translate(0,0.5)"><line stroke="currentColor" x2="0"></line><text fill="currentColor" x="-6" dy="0.32em">10</text></g></g></g></svg>
`
  const [selectedValue, setSelectedValue] = useState("yes");
  const [error, setError] = useState({});
  const [svgBase64, setSvgBase64] = useState("");
  const navigate = useNavigate();
  const [selectedValue1, setSelectedValue1] = useState("all");
  const classes = Styles();
  const radioButtonData = [
    {
      id: "yes",
      label: STRINGS.NO_RECURRING,
    },
    { id: "no", label: STRINGS.YES_RECURRING },
  ];
  const radioButtonData1 = [
    {
      id: "all",
      label: STRINGS.INCLUDE_ALL_EXPORTS,
    },
    { id: "partial", label: STRINGS.INCLUDE_SELECTED_EXPORTS },
  ];
  const modalHeaderData = {
    heading: {
      id: STRINGS.EMAIL_THIS_DASHBOARD,
      label: STRINGS.EMAIL_THIS_DASHBOARD,
    },
  };
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const handleChange1 = (event) => {
    setSelectedValue1(event.target.value);
  };
  const handleBase = () => {
    // let svgXML = new XMLSerializer().serializeToString(<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
    // <circle cx="50" cy="50" r="40" stroke="black" stroke-width="3" fill="red" />
    // </svg>)

    // Encode the SVG XML as Base64
    // const base64EncodedSVG = btoa(svgXML);
    // console.log("SVGXML",base64EncodedSVG)
    // const blob = new Blob([value], { type: "image/svg+xml" });

    // // Create a Data URL (Base64) from the Blob
    // const reader = new FileReader();
    // reader.onload = function () {
    //   const base64Data = reader.result;
    //   console.log("BLOB",base64Data)
    //   setSvgBase64(base64Data);
    // };
    // reader.readAsDataURL(blob);
  };

  // const convertBase64 = (file) => {
  //   return new Promise((resolve, reject) => {
  //     const fileReader = new FileReader();
  //     fileReader.readAsDataURL(file);
  //     fileReader.onload = () => {
  //       resolve(fileReader.result);
  //     };
  //     fileReader.onerror = () => {
  //       reject(error);
  //     };
  //   });
  // };

  const handleSvg = async () => {
    handleBase();
    try {
      const payload = {
        dashboard_id: dashboardID[0],
        emails:["aijaz.ahamed@reachiq.ai"],
        svg: [
          {
            _id: widget[0]?._id,
            img: btoa(value),
          },
          {
            _id: widget[0]?._id,
            img: btoa(value),
          },
          {
            _id: widget[0]?._id,
            img: btoa(value),
          },
          {
            _id: widget[0]?._id,
            img: btoa(value),
          },
          {
            _id: widget[0]?._id,
            img: btoa(value),
          },
          {
            _id: widget[0]?._id,
            img: btoa(value),
          },
          {
            _id: widget[0]?._id,
            img: btoa(value),
          },
        ],
      };
      const response = await postRequest(
        navigate,
        dashboardEndpoints.shareSvg,
        payload
      );
    } catch (e) {}
  };

  const modalBodyData = (
    <div className={classes.bodyShareContainer}>
      <div>
        <TypographyInline
          size={"sm"}
          color={GREY.QUATINARY}
          fontWeight={fontWeight.MEDIUM}
          label={STRINGS.IS_THIS_RECURRING}
        />
      </div>
      <div>
        <RadioButton
          value={selectedValue}
          onChange={handleChange}
          items={radioButtonData}
        />
      </div>
      <div>
        <TypographyInline
          size={"sm"}
          color={GREY.QUATINARY}
          fontWeight={fontWeight.MEDIUM}
          label={STRINGS.INTERNAL_RECIPIENTS}
        />
        <div className={classes.paddingShare}>
          <AutoCompleteCustom
            LeftIcon=""
            items={selectData}
            dropdownId="sdfg"
            paperHeight="13vh"
            //   valueState={valueState}
            //   setValueState={setValueState || []}
            //   idState={idVal || []}
            //   setIdState={setIdVal}
            //   onChange={(e) => handleMeeting(e)}
            papermenuclass={classes.dropdownlist}
            size={"md40"}
          />
        </div>
      </div>
      <div>
        <TypographyInline
          size={"sm"}
          color={GREY.QUATINARY}
          fontWeight={fontWeight.MEDIUM}
          label={STRINGS.OTHER_RECIPIENTS}
        />
        <div className={classes.paddingShare}>
          <InputField
            size={"sm36"}
            // errormessage={props.cloneErr.length !== 0 ? props.cloneErr : ""}
            // variant={"disabled"}
            placeholder={STRINGS.ADD_OTHER_RECIPIENTS}
            // value={cloneWidgetName}
            // onChange={handleInput}
            iscapitalize
          />
        </div>
      </div>
      <div className={classes.borderLine}></div>
      <div>
        <TypographyInline
          size={"sm"}
          color={GREY.QUATINARY}
          fontWeight={fontWeight.MEDIUM}
          label={STRINGS.EMAIL_SUBJECT}
        />
        <div className={classes.paddingShare}>
          <InputField
            size={"sm36"}
            // errormessage={props.cloneErr.length !== 0 ? props.cloneErr : ""}
            // variant={"disabled"}
            placeholder={STRINGS.ENTERSUBJECT}
            // value={cloneWidgetName}
            // onChange={handleInput}
            iscapitalize
          />
        </div>
      </div>
      <div>
        <TypographyInline
          size={"sm"}
          color={GREY.QUATINARY}
          fontWeight={fontWeight.MEDIUM}
          label={STRINGS.MESSAGE}
        />
        <div className={classes.paddingShare}>
          <TextArea
            // value={offerings}
            // variant={validations.offerings ? "error" : "default"}
            // errormessage={validations.offerings}
            // onChange={(e) => setOfferings(e?.target?.value)}
            placeholder={STRINGS.WRITE_MSG_HERE}
          />
        </div>
      </div>
      <div>
        <TypographyInline
          size={"sm"}
          color={GREY.QUATINARY}
          fontWeight={fontWeight.MEDIUM}
          label={STRINGS.REPORTS_IN_EXPORT}
        />
      </div>
      <div>
        <RadioButton
          value={selectedValue1}
          onChange={handleChange1}
          items={radioButtonData1}
        />
      </div>
    </div>
  );
  const modalFooterLeftData = <div></div>;
  const modalFooterRightData = (
    <Box className={classes.flexShare}>
      <Button label={STRINGS.CANCEL} variant={"ghost"} size={"sm36"} />
      <Button
        label={STRINGS.SAVE}
        size={"sm36"}
        variant={"primary"}
        onClick={handleSvg}
      />
    </Box>
  );
  return (
    <CustomModal
      open={open}
      close={() => setOpen(false)}
      header={modalHeaderData}
      children={modalBodyData}
      footer={{
        left: modalFooterLeftData,
        right: modalFooterRightData,
      }}
      width={"607px"}
    />
  );
};

export default ShareDashboardModal;
